import { Controller } from "@hotwired/stimulus"

// Copy-to-clipboard for a block of text carried on the button itself
// (data-copy-text-value), with the confirmation ON the button rather than in a
// toast - a research card can have half a dozen of these and a toast cannot
// tell you WHICH one you just copied.
export default class extends Controller {
    static values = { text: String, label: String }

    copy(event) {
        event?.preventDefault()
        event?.stopPropagation()

        let text = this.textValue
        if (!text) return

        this._write(text).then((ok) => this._flash(ok))
    }

    _write(text) {
        // navigator.clipboard is https-only; the execCommand fallback keeps
        // this working on plain-http dev hosts and older webviews.
        if (navigator.clipboard?.writeText) {
            return navigator.clipboard.writeText(text).then(() => true).catch(() => this._fallback(text))
        }
        return Promise.resolve(this._fallback(text))
    }

    _fallback(text) {
        try {
            let area = document.createElement("textarea")
            area.value = text
            area.setAttribute("readonly", "")
            area.style.position = "fixed"
            area.style.opacity = "0"
            document.body.appendChild(area)
            area.select()
            let ok = document.execCommand("copy")
            area.remove()
            return ok
        } catch {
            return false
        }
    }

    _flash(ok) {
        let button = this.element
        let label = button.querySelector("[data-copy-text-target='label']") || button
        if (this._restore) clearTimeout(this._restore)
        this._original ??= label.textContent
        label.textContent = ok ? "Copied" : "Press ⌘C"
        button.classList.toggle("is-copied", ok)
        this._restore = setTimeout(() => {
            label.textContent = this._original
            button.classList.remove("is-copied")
        }, 1600)
    }
}
